
<template>
  <div
    class="home-wapper"
    :style="{ overflowY: `${showDialog ? 'hidden' : 'auto'}` }"
  >
    <div class="home-top-bg">
      <img
        :src="
          type == 4
            ? currentData.activityImg
            : type == 2
            ? currentData.coverImg
            : currentData.articleImg
        "
        alt=""
      />
    </div>
    <div class="home-content">
      <div class="home-title">
        <div>
          <div class="title">
            {{
              currentData.activityName ||
              currentData.name ||
              currentData.className
            }}
          </div>
          <div class="infoBox" style="color:#000001;margin-top: 20px;" v-if="currentData.source==2&&currentData.cityBookstoreName">
            <span>主办方 : {{ currentData.cityBookstoreName}}</span>
          </div>
          <div
            class="infoBox"
            style="color: #000001; margin-top: 10px"
            v-if="type == 4"
          >
            <span
              >活动时间 | {{ currentData.startTime
              }}{{ currentData.endTime ? "-" : ""
              }}{{ currentData.endTime ? currentData.endTime : "" }}
              {{ currentData.time }}</span
            >
          </div>
          <div
            class="infoBox"
            style="color: #000001; margin-top: 10px"
            v-if="(currentData.teacherId && type == 4) || type == 2"
          >
            <span>主讲老师 | {{ currentData.teacherName }}老师</span>
          </div>
          <div class="title-item" v-if="type == 1">
            <div class="infoBox" style="color: #000001; margin-top: 35px">
              <span>报名费用 |</span>
               <span style="color: #950402; margin-left: 5px">
                {{
                  currentData.classPrice == "0.00" || !currentData.classPrice
                    ? "免费"
                    : currentData.classPrice
                }}{{ currentData.classPrice != "0.00" ? "元/人" : "" }}
              </span>
            </div>
            <div style="color: #000001; margin-top: 35px">
              {{ currentData.signUpNum || "0" }}人加入{{
                type == 4 ? "活动" : "学习"
              }}
            </div>
          </div>
          <div class="title-item" v-if="type == 4&&currentData.activityType!=1 || type == 2">
            <div class="infoBox" style="color: #000001; margin-top: 10px" v-if="currentData.source==1">
              <span>报名费用 |</span>
              <span style="color: #950402; margin-left: 5px" v-if="currentData.source==2&&(currentData.cityBookstoreId||currentData.cityBookstoreId==0)">
                {{
                  currentData.ordinaryPrice == "0.00" || !currentData.ordinaryPrice
                    ? "免费"
                    : currentData.ordinaryPrice
                }}{{ currentData.ordinaryPrice != "0.00" ? "元/人" : "" }}
              </span>
              <span v-if="type == 2" style="color: #950402; margin-left: 5px">
                {{summerShowPrice}}{{summerShowPrice=='免费'?'':'元/人'}}
              </span>
              <span style="color: #950402; margin-left: 5px" v-if="currentData.source!=2&&type!=2">
                {{
                  currentData.totalMoney == "0.00" || !currentData.totalMoney
                    ? "免费"
                    : currentData.totalMoney
                }}{{ currentData.totalMoney != "0.00" ? "元/人" : "" }}
              </span>
            </div>
             <div class="infoBox" style="color:#000001;margin-top: 10px;" v-if="currentData.source==2">
                <span>报名费用 | </span>
                <span style="color:#950402;margin-left:5px;" v-if="type==4&&currentData.signUpType==1">免费</span>
                <span style="color:#950402;margin-left:5px;" v-if="type==4&&currentData.signUpType==2">现场收费({{currentData.scenePrice}}元/人)</span>
              </div>
            <div style="color: #000001; margin-top: 10px">
              {{ currentData.signUpNum || "0" }}人加入{{
                type == 4 ? "活动" : "学习"
              }}
            </div>
          </div>
        </div>
      </div>
      <!-- 详情内容 -->
      <div class="classContent">
        <div style="font-weight: 900; color: #6f4630; font-size: 20px">
          详情内容
        </div>
        <div
          class="classDes"
          v-html="currentData.activityContent"
          v-if="type == 4"
        ></div>
        <!-- <img :src="currentData.summerCampImg" v-if="type==2" mode="fill" /> -->

        <div
          class="classDes"
          v-html="currentData.summerCampContent"
          v-if="type == 2"
        ></div>
        <!-- <div  v-else> -->
        <p v-else class="big_text" v-html="currentData.classIntroduce"></p>
        <!-- </div> -->
      </div>
    </div>
    <div class="btnView" @click="goSign">
      <div class="btnBox">
        <span style="margin-left: 0px">立即报名</span>
      </div>
    </div>
    <!-- 报名弹窗 -->
    <div v-if="showDialog" class="dialog">
      <div class="maskBox" v-if="abnormalView">
        <div class="topView">
          <span>温馨提示</span>
           <img src="../../static/images/close.png"  style="width:20px;height:20px;" @click="closeAbnormal"/>
        </div>
        <div class="abnormalBox">
          <div class="abnormalText">您的账号异常，请联系国易坊小程序系统客服</div>
          <img src="../../static/images/gyf.jpg"  class="gyfImg"/>
        </div>
      </div>
      <div class="maskBox" v-if="showForm">
        <div class="maskTitle">确认报名</div>
        <div class="mask-box">
          
          <div class="formItem">
            <span class="home-label">参与者手机号:</span>
            <input
              type="text"
              maxlength="11"
              v-model="phone"
              @input="phoneFn"
              placeholder="请输入微信绑定手机号"
            />
          </div>
          <div class="formItem">
            <span class="home-label">参与者真实姓名:</span>
            <input
              type="text"
              maxlength="4"
              v-model="name"
              @input="nameFn"
              placeholder="请输入参与者真实姓名"
            />
          </div>
          <div class="formItem">
            <span class="home-label">邀请人手机号:</span>
            <input
              type="text"
              maxlength="11"
              v-model="invitePhone"
              @input="invitePhoneFn"
              placeholder="请输入邀请人手机号"
            />
          </div>
          <div class="formItem" v-if="currentData.isCityStore==1">
            <span class="home-label">城市书院:</span>
            <el-select v-model="bookStoreVal" filterable placeholder="请选择" 
                       ref="select" @focus="clear" @hook:mounted="clear" @visible-change='clear'>
              <el-option
                v-for="item in cityBookList"
                :key="item.id"
                :label="item.bookstoreName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="signView">
          <div
            class="btn0"
            style="font-weight: 900; color: #8d806d; background: #ededed"
            @click="cancelSign"
          >
            我再想想
          </div>
          <div
            class="btn0"
            style="font-weight: 900; color: #fff; background: #6f4630"
            @click="submitForm"
          >
            确认报名
          </div>
        </div>
      </div>
      <div class="maskBox" v-if="showSummer">
        <div class="maskTitle">确认报名</div>
          <div class="mask-box" style="min-height:100px;">
            <div class="formItem">
            <span class="home-label">小领袖姓名:</span>
            <input
              type="text"
              maxlength="4"
              v-model="summerName"
              @input="summerNameFn"
              placeholder="请输入小领袖姓名"
            />
          </div>
           <div class="formItem">
            <span class="home-label">家长姓名:</span>
            <input
              type="text"
              v-model="parentName"
              @input="parentNameFn"
              placeholder="请输入家长姓名"
            />
          </div>
          
          <!-- <div class="formItem">
            <span class="home-label">小领袖身份证号:</span>
            <input
              type="text"
              maxlength="18"
              v-model="IDNumber"
              @input="idNumberFun"
              placeholder="请输入孩子身份证号"
            />
          </div> -->
           <div class="formItem">
            <span class="home-label">家长手机号:</span>
            <input
              type="text"
              maxlength="11"
              v-model="parentPhone"
              @input="parentPhoneFn"
              placeholder="请输入家长手机号"
            />
          </div>
           <div class="formItem">
            <span class="home-label">推荐人手机号:</span>
            <input
              type="text"
              maxlength="11"
              v-model="agentPhone"
              @input="agentPhoneFn"
              placeholder="请输入推荐人手机号"
            />
          </div>
        </div>
          <div class="signView">
          <div
            class="btn0"
            style="font-weight: 900; color: #8d806d; background: #ededed"
            @click="cancelSign"
          >
            我再想想
          </div>
          <div
            class="btn0"
            style="font-weight: 900; color: #fff; background: #6f4630"
            @click="submitSummerForm"
          >
            确认报名
          </div>
        </div>
      </div>
      <div class="maskBox" v-if="showSummerForm">
        <div class="maskTitle">报名信息</div>
         <div class="mask-box">
          <div class="formItem1">
            <span class="home-label">小领袖证件类型:</span>
             <el-radio-group v-model="idType" @input="idTypeFun" class="dressBox">
              <el-radio label="1" style="width:40px;">身份证</el-radio>
              <el-radio label="2" style="width:40px;">护照</el-radio>
              <el-radio label="3" style="width:100px;">港澳通行证</el-radio>
            </el-radio-group>
          </div>
          <div class="formItem">
            <span class="home-label">小领袖身份证号:</span>
            <input
              type="text"
              maxlength="18"
              v-model="identityNum"
              @input="identityNumFun"
              placeholder="请输入小领袖身份证号"
            />
          </div>
           <div class="formItem">
            <span class="home-label">性别:</span>
             <el-radio-group v-model="sex" @input="sexFun">
              <el-radio label="1" >男</el-radio>
              <el-radio label="2" >女</el-radio>
            </el-radio-group>
          </div>
           <div class="formItem">
            <span class="home-label">年龄:</span>
            <input
              type="number"
              v-model="summerAge"
              @input="ageFn"
              placeholder="请输入年龄"
            />
          </div>
           <div class="formItem">
            <span class="home-label">身高(cm):</span>
            <input
              type="text"
              v-model="height"
              @input="heightFn"
              placeholder="请输入身高"
            />
          </div>
           <div class="formItem">
            <span class="home-label">体重(kg):</span>
            <input
              type="text"
              v-model="weight"
              @input="weightFn"
              placeholder="请输入体重"
            />
          </div>
           <div class="formItem">
            <span class="home-label">民族:</span>
            <input
              type="text"
              v-model="nation"
              @input="nationFn"
              placeholder="请输入民族"
            />
          </div>
           <div class="formItem1">
            <span class="home-label">服装上衣尺寸:</span>
             <el-radio-group v-model="clothingSize" @input="clothingSizeFun" class="dressBox">
              <el-radio :label="item.value" v-for="(item,index) in clothDownData" :key="index">{{item.label}}</el-radio>
            </el-radio-group>
          </div>
          
          
           <div class="formItem">
            <span class="home-label">小领袖生日类型:</span>
             <el-radio-group v-model="dateType" @input="dateTypeFun">
              <el-radio label="2" style="width:40px;">阴历</el-radio>
              <el-radio label="1" style="width:40px;">阳历</el-radio>
            </el-radio-group>
          </div>
           <div class="formItem">
            <span class="home-label">小领袖出生日期:</span>
            <input
              type="text"
              v-model="birthday"
              @input="birthdayFn"
              placeholder="请输入小领袖出生日期"
            />
          </div>
          <div class="formItem">
            <span class="home-label">来自哪个城市:</span>
            <input
              type="text"
              v-model="cityName"
              @input="cityNameFn"
              placeholder="请输入城市"
            />
          </div>
          <!-- <div class="formItem">
            <span class="home-label">家长姓名:</span>
            <input
              type="text"
              v-model="parentName"
              @input="parentNameFn"
              placeholder="请输入家长姓名"
            />
          </div> -->
          <!-- <div class="formItem">
            <span class="home-label">家长手机号:</span>
            <input
              type="text"
              maxlength="11"
              v-model="parentPhone"
              @input="parentPhoneFn"
              placeholder="请输入家长电话"
            />
          </div> -->
          <!-- <div class="formItem">
            <span class="home-label">推荐人手机号:</span>
            <input
              type="text"
              maxlength="11"
              v-model="agentPhone"
              @input="agentPhoneFn"
              placeholder="请输入推荐人手机号"
            />
          </div> -->
           <div class="formItem1">
            <span class="home-label">首次入营还是复训:</span>
             <el-radio-group v-model="joinNum" @input="joinNumFun" class="numberBox">
              <el-radio :label="item.value"  v-for="(item,index) in joinNumData" :key="index">{{item.label}}</el-radio>
            </el-radio-group>
          </div>
          <!-- <div class="formItem1">
            <span class="home-label">付款截图(要求:有付款日期时间流水号饿有效截图，首次参加的请把学费和伙食费截图都上传):</span>
            <div class="uploadBox" >
              <div class="picBox" v-for="(item,index) in payPic" :key="index">
                <img :src="item" class="picItem" />
                <span class="delText" @click="telPic(index)">删除</span>
              </div>
            <el-upload
              class="avatar-uploader"
              action="http://admin.guoyifang55.com/api/upload"
              :show-file-list="false"
              :on-success="handlePicSuccess"
              >
             <span class="uploadText">+</span>
            </el-upload>
             </div>
          </div> -->
           <!-- <div class="formItem">
            <span class="home-label">首席团队:</span>
            <input
              type="text"
              v-model="age"
              @input="nameFn"
              placeholder="请输入首席团队"
            />
          </div> -->
           <div class="formItem1">
            <span class="home-label">对本次领袖营的期待:</span>
            <input
              type="text"
              v-model="expectContent"
              @input="expectContentFn"
              placeholder="请输入对本次领袖营的期待"
            />
          </div>
           <div class="formItem1">
            <span class="home-label">备注:</span>
            <input
              type="text"
              v-model="remarks"
              @input="remarksFun"
              placeholder="请输入备注"
            />
          </div>

            <div class="signView">
          <!-- <div
            class="btn0"
            style="font-weight: 900; color: #8d806d; background: #ededed"
            @click="cancelSign"
          >
            我再想想
          </div> -->
          <div
            class="btn1"
            style="font-weight: 900; color: #fff; background: #6f4630"
            @click="checkSummerForm"
          >
            提交信息
          </div>
        </div>
         </div>
      </div>
      <div class="maskBox" v-if="showPrice">
        <div class="maskTitle">确认报名</div>
         <div class="mask-Pricebox" v-if="showCusmtorPay">
        <div class="payMask-box" style="text-align: center;">
          <span>支付金额</span>
          <input
            class="shop-info-input"
            placeholder="请输入金额"
            placeholder-class="input-place"
            @input="getPayMoney"
            v-model="payMoney"
          />
          </div>
        </div>
        <div
          class="mask-Pricebox"
          v-if="priceData && priceData.priceList&&priceData.priceList.length"
        >
          <div style="margin-bottom: 15px; font-size: 18px">价格明细:</div>
          <div class="priceItem">
            <div
              v-for="(item, index) in priceData.priceList"
              :key="index"
              class="priceInfoBox"
            >
              <span style="margin-left: 10px">{{ item.name }}:</span>
              <span>{{ item.price || "0" }}</span>
            </div>
          </div>
          <div style="margin-top: 10px; color: #6f4630">
            <span style="margin-bottom: 15px; font-size: 18px"
              >本次需要支付:</span
            >
            <span style="margin-bottom: 15px; font-size: 18px"
              >￥{{ priceData.payAmount || "0" }}元</span
            >
          </div>
        </div>
        <div class="mask-Pricebox"
          v-if="priceData && priceData.bookActivityPriceDto">
          <div class="priceInfoBox">
             <span style="margin-left: 10px">活动会员价:</span>
            <span>{{ priceData.bookActivityPriceDto.vipPrice || "0" }}</span>
            <span style="margin-left: 10px">活动非会员价:</span>
            <span>{{ priceData.bookActivityPriceDto.ordinaryPrice || "0" }}</span>
          </div>
          <div style="margin-top: 10px; color: #6f4630">
            <span style="margin-bottom: 15px; font-size: 18px"
              >本次需要支付:</span
            >
            <span style="margin-bottom: 15px; font-size: 18px"
              >￥{{ priceData.payAmount || "0" }}元</span
            >
          </div>

        </div>
        <div class="signView">
          <div
            class="btn0"
            style="font-weight: 900; color: #8d806d; background: #ededed"
            @click="cancelSign"
          >
            我再想想
          </div>
          <div
            class="btn0"
            style="font-weight: 900; color: #fff; background: #6f4630"
            @click="submitOrder"
            v-if="currentData.activityType !=1"
          >
            确认支付
          </div>
          <div
            class="btn0"
            style="font-weight: 900; color: #fff; background: #6f4630"
            @click="useCustomPay"
            v-if="currentData.activityType ==1"
          >
            确认支付
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Picker } from "vant";
// 判断是否为微信环境
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    "micromessenger"
  );
};
export default {
  name: "Home",
  components: {
    // vanPicker: Picker,
  },
  data() {
    return {
      phone: "", //用户手机号
      name: "", //姓名
      invitePhone: "", //  邀请人手机号
      IDNumber:'',    // 孩子身份证号
      currentData: {
        content:
          '<p></p><div class="media-wrap image-wrap"><img class="media-wrap image-wrap" src="https://resources.guoyifang55.com/2023%2F03%2F14%2F0091ec8f27fac8cf7e8b000bbcf63ef7.jfif"/></div><p></p>',
      },
      showDialog: false, //  报名弹窗
      showForm: false, // 报名表单
      showSummer:false,   // 夏令营孩子身份证
      showSummerForm:false,   // 夏令营报名信息
      showPrice: false, // 价格明细
      showCusmtorPay:false,   // 自定义价格支付
      userData: null, //  个人信息
      abnormalView:false,
      currentId: "", // 当前课程或者活动id
      type: "", // 类型   1--课程 2---夏令营 3---证书报名  4--活动
      priceData: null, //  价格明细
      IP: "", // 当前设备ip
      clientType: "", // 设备类型  iOS, Android, Wap
      url: "",
      code: "",
      data: {},
      childData:{},    // 孩子信息// 真正大人信息
      childInfoData:{},    //真正孩子信息
      isAllChildInfo:null,   // 孩子信息是否完整
      clothDownData:[],
      joinNumData:[],
      sex:'1',
      joinNum:'',
      payPic:[], 
      summerName:'',
      summerAge:'',
      height:'',
      weight:'',
      clothingSize:'',
      cityName:'',
      expectContent:'',
      nation:'',
      remarks:'',
      identityNum:'',
      dateType:'1',
      birthday:'',
      idType:'1',
      parentName:'',
      parentPhone:'',
      agentPhone:'',
      summerShowPrice:'免费',     // 夏令营展示价格
      currentOrderData:'',          // 支付订单数据
      payMoney:'',   //     支付金额
      bookStoreVal:'',
      cityBookList:[],     //   城市书院列表
      oldChildData:{},     // 查询出来的小孩信息
    };
  },

  mounted() {
    this.currentId = this.$route.query.currentId;
    this.type = this.$route.query.type;
    if (!this.$route.query.currentId) {
      return;
    }
    this.getDetailsData(this.$route.query.type);
    this.init();
  },
  created() {
    // this.getWechatCode();
    this.getMapData()
    this.getCityData()
  },

  methods: {
    init() {
      const ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        this.clientType = "wecht";
        this.getWechatCode();
      }else if(ua.match(/AlipayClient/i) == 'alipayclient'){
        this.clientType = "alipay";
      }else{
        this.clientType = "wap";
      }
      // console.log(this.clientType,'this.clientType')
    },

    clear(async){
      this.$nextTick(()=>{
        if(!async){
          setTimeout(()=>{
            const { select } = this.$refs;
            const input = select.$el.querySelector('.el-input__inner');
            input.removeAttribute('readonly');
          },200)
        }
      })

    },


    // 获取字典数据
    async getMapData(){
      let that = this;
      let res = await that.$api.selectTree()
      if(res.data.code=='0000'){
        that.clothDownData = res.data.data['CLOTHING_SIZE']
        this.joinNumData = res.data.data['JOIN_NUM']
      }
    },
    // 获取城市书院数据
    async getCityData(){
      let that = this;
      let res = await that.$api.getCityList()
      if(res.data.code=='0000'){
        let list = res.data.data;
        list.unshift({
          id:'9999',
          bookstoreName:'北京国易坊'
        })
        that.cityBookList = list;

      }
      
    },

    //  获取详情内容
    async getDetailsData(type) {
      let _this = this;
      if (type == 4) {
        //  活动
        let result = await _this.$api.getActivityDetails({
          id: _this.currentId,
        });
        if (result.data.code == "0000") {
          let data = result.data.data;
          data.endTime =
            data.endTime.slice(0, 10).split("-").join(".") +
            "(" +
            data.endTime.slice(11, 16) +
            ")";
          let time0 = data.startTime;
          let time1 = data.endTime;
          data.time =
            "(" +
            data.startTime.slice(11, 16) +
            "~" +
            data.endTime.slice(11, 16) +
            ")";
          data.startTime =
            (time0.slice(5, 6) == "0" ? time0.slice(6, 7) : time0.slice(5, 7)) +
            "月" +
            (time0.slice(8, 9) == "0"
              ? time0.slice(9, 10)
              : time0.slice(8, 10)) +
            "日";
          data.endTime =
            (time1.slice(5, 6) == "0" ? time1.slice(6, 7) : time1.slice(5, 7)) +
            "月" +
            (time1.slice(8, 9) == "0"
              ? time1.slice(9, 10)
              : time1.slice(8, 10)) +
            "日";
          if (data.startTime == data.endTime) {
            data.endTime = "";
          }
          _this.currentData = data;
        }
      } else if (type == 2) {    //  夏令营
        let priceNum = '免费';
        let result = await _this.$api.getSummerDetails({
          id: _this.currentId,
        });
        // console.log("resule------", result);
        if (result.data.code == "0000") {
          let data = result.data.data;
          data.endTime =
            data.endTime.slice(0, 10).split("-").join(".") +
            "(" +
            data.endTime.slice(11, 16) +
            ")";
          let time0 = data.startTime;
          let time1 = data.endTime;
          data.time =
            "(" +
            data.startTime.slice(11, 16) +
            "~" +
            data.endTime.slice(11, 16) +
            ")";
          data.startTime =
            (time0.slice(5, 6) == "0" ? time0.slice(6, 7) : time0.slice(5, 7)) +
            "月" +
            (time0.slice(8, 9) == "0"
              ? time0.slice(9, 10)
              : time0.slice(8, 10)) +
            "日";
          data.endTime =
            (time1.slice(5, 6) == "0" ? time1.slice(6, 7) : time1.slice(5, 7)) +
            "月" +
            (time1.slice(8, 9) == "0"
              ? time1.slice(9, 10)
              : time1.slice(8, 10)) +
            "日";
          if (data.startTime == data.endTime) {
            data.endTime = "";
          }
          _this.currentData = data;
          if(data.totalMoney == '0.00'&& data.pricesList){
            let priceAll = data.pricesList;
            for (var i = 0; i < priceAll.length; i++) {
              if (priceAll[i].price != '0.00') {
                priceNum = priceAll[i].price
                break;
              }
          }
          }else{
            priceNum = data.totalMoney
          }
        _this.summerShowPrice = priceNum

        }
      } else {
        // // 课程  
        let result = await _this.$api.getClassDetails({
          classId: _this.currentId,
        });
        if (result.data.code == "0000") {
          _this.currentData = result.data.data;
        }
      }
    },
    submitSummerForm(){
      let reg2 = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;   // 身份证校验  
      if(!this.summerName){
        this.$Toast("请输入小领袖姓名");
        return;
      }
      // if(this.IDNumber == ''){
      //    this.$Toast("请输入身份证号");
      //   return;
      // }else if(!reg2.test(this.IDNumber)){
      //   this.$Toast("请输入正确的身份证号");
      //   return;
      // } 
      if(!this.parentPhone){
        this.$Toast("请输入家长电话");
        return;
      }else if(this.parentPhone.length<11){
        this.$Toast("请输入正确家长电话");
        return;
      } else if(!this.parentName){
        this.$Toast("请输入家长姓名");
        return;
      }else if(!this.agentPhone){
        this.$Toast("请输入推荐人手机号");
        return;
      }else if(this.agentPhone.length<11){
        this.$Toast("请输入正确推荐人手机号");
        return;
      }
      // this.showDialog = false;
      // this.showSummer = false;
      this.saveSummerData()
     
      // this.getChildInfoFun()
      // this.showSummerForm = true;
    },

    // 夏令营支付完成填写信息 showSummer
    async saveSummerData(){
      let that = this;
      let res = await that.$api.commitChildInfo({
        agentPhone:that.agentPhone,
        parentPhone:that.parentPhone,
        childName:that.summerName,
        // orderId:that.currentOrderData.orderId,
        parentName:that.parentName,
      })
       if(res&&res.data.code == '0000'){
        this.showDialog = false;
        this.showSummer = false;
        that.childData = res.data.data;
        this.getSummerPriceList()
        // this.$alert('报名成功','提示',{
        //   confirmButtonText: '关闭网页',
        //   callback: action => {
        //     window.WeixinJSBridge.call('closeWindow') 
        //   }
        // })
       }else {
          this.$Toast({
            message:res.data.msg,
            duration: 2000
          });
        // let msg = res.data.msg;
        // if(msg.indexOf('账号异常')>-1){
        //   this.showDialog = true
        //   this.abnormalView = true
        //   this.showForm = false;
        //   this.showPrice = false;
        // }else{
        //   this.$Toast({
        //     message:res.data.msg,
        //     duration: 2000
        //   });
        // }
        return;
      }
    },

    // 根据身份证获取小孩信息
    async getChildInfoFun(){
      let that = this;
      let res = await that.$api.getChildInfoData({identityNum:that.IDNumber,phone:that.parentPhone,childName:that.summerName,})
      if(res&&res.data.code == '0000'){
        let data = res.data.data;
        that.childData = res.data.data.user;
        that.childInfoData = res.data.data.child;
        that.isAllChildInfo = res.data.data.childInfo;
        that.getSummerPriceList()
      }else{
         this.$Toast(res.data.data);
         return
      }
    },
    // 删除图片
    telPic(index){
      this.payPic.splice(index,1)
    },
    // 校验夏令营表单   saveChildFun
    checkSummerForm(){
      let reg = /^[0-9]+(\.[0-9]+)?$/;    // 数字小数校验
      let reg2 = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;   // 身份证校验
      const ageRegex = /^[1-9]\d*$/;
      if(this.idType==1&&this.identityNum){
        if(!reg2.test(this.identityNum)){
          this.$Toast("请输入正确身份证号");
          return;
        }
      }
      if(!this.sex){
        this.$Toast("请选择性别");
        return;
      }else if(!this.summerAge){
        this.$Toast("请输入年龄");
        return;
      }else if(!ageRegex.test(this.summerAge)){
        this.$Toast('年龄为正整数');
        return;
      }
      else if(!this.height){
        this.$Toast("请输入身高");
        return;
      }else if(!this.weight){
        this.$Toast("请输入体重");
        return;
      }else if(!this.clothingSize){
        this.$Toast("请选择上衣尺寸");
        return;
      }else if(!reg.test(this.height)){
        this.$Toast("身高只能输入数字");
        return;
      }else if(!reg.test(this.weight)){
        this.$Toast("体重只能输入数字");
        return;
      }else if(!this.identityNum){
        this.$Toast("请输入身份证号");
        return;
      }
      // else if(!reg2.test(this.identityNum)){
      //   this.$Toast("请输入正确身份证号");
      //   return;
      // }
      else if(!this.dateType){
        this.$Toast("请选择生日类型");
        return;
      }
      if(!this.birthday){
        this.$Toast("请输入出生日期");
        return;
      }else if(!this.cityName){
        this.$Toast("请输入城市");
        return;
      }else if(!this.nation){
        this.$Toast('请输入民族');
        return
      }
      // else if(!this.parentName){
      //   this.$Toast("请输入家长姓名");
      //   return;
      // }
      // else if(!this.parentPhone){
      //   this.$Toast("请输入家长电话");
      //   return;
      // }else if(this.parentPhone.length<11){
      //   this.$Toast("请输入正确家长电话");
      //   return;
      // }
      // else if(!this.agentPhone){
      //   this.$Toast("请输入推荐人手机号");
      //   return;
      // }else if(this.agentPhone.length<11){
      //   this.$Toast("请输入正确推荐人手机号");
      //   return;
      // }
      else if(!this.joinNum){
        this.$Toast("请选择参加次数");
        return;
      }
      // else if(!this.payPic.length){
      //   this.$Toast("请上传付款截图");
      //   return;
      // }
      this.submitSummerAllForm()

    },
    //  提交夏令营表单
    async submitSummerAllForm(){
      let that = this;
      let res = await that.$api.complateChildInfo({
        // userId:'11588',
        // childId:'446',
        // userId:that.childData.id,
        // childId:that.childInfoData.id,
        // name:that.summerName,
        oldChildId:that.oldChildData.id||'',
        identityNum:that.identityNum,
        // orderId:'1382',
        orderId:that.currentOrderData.orderId,
        sex:that.sex,
        age:that.summerAge,
        dateType:that.dateType,
        birthday:that.birthday,
        height:that.height,
        weight:that.weight,
        clothingSize:that.clothingSize,
        cityName:that.cityName,
        joinNum:that.joinNum,
        nation:that.nation,
        // payImg:that.payPic.join(','),
        expectContent:that.expectContent,
        remarks:that.remarks,
        // parentName:that.parentName,
        // parentPhone:that.parentPhone,
        // agentPhone:that.agentPhone,
        idType:that.idType,
      })
      if(res.data.code == '0000'){
        // this.$Toast("提交成功");
        this.showDialog = false;
        this.showSummerForm = false;
        this.$alert('提交成功','提示',{
          confirmButtonText: '关闭网页',
          callback: action => {
            window.WeixinJSBridge.call('closeWindow') 
          }
        })
        // 
      }else{
         this.$Toast(res.data.data);
         return
      }
    },


    // 获取夏令营价格明细
    async getSummerPriceList(){
      let that = this;
      let res = await that.$api.getChildPriceData({
        phone: '',
        name: '',
        agentPhone: '',
        classId: this.currentId,
        type: this.type,
        userId:this.childData.userId,
        childId:this.childData.childId,
      })
      if (res.data.code == "0000") {
        this.priceData = res.data.data.priceRsp;
        this.userData = res.data.data.user;
        if (
          res.data.data.priceRsp.payAmount != 0 ||
          res.data.data.priceRsp.payAmount != "0.00"
        ) {
          that.goPay();
        } else {
          that.submitOrder();
        }
      } else {
       let msg = res.data.msg;
        if(msg.indexOf('账号异常')>-1){
          this.showDialog = true
          this.abnormalView = true
          this.showForm = false;
          this.showPrice = false;
        }else{
          this.$Toast({
            message:res.data.msg,
            duration: 2000
          });
        }
        return;
      }

    },



    // 提交表单  this.$Toast("请输入移动号码");
    submitForm() {
      let datas = this.currentData;
      if (this.phone == "") {
        this.$Toast("请输入手机号码");
        return;
      } else if (this.phone.length < 11) {
        this.$Toast("请输入正确的手机号码");
        return;
      } else if (!this.name) {
        this.$Toast("请输入真实姓名");
        return;
      } else if (!this.invitePhone) {
        this.$Toast("请输入邀请人手机号码");
        return;
      } else if (this.invitePhone.length < 11) {
        this.$Toast("请输入正确的邀请人手机号码");
        return;
      }
      if(datas.isCityStore == 1 && !this.bookStoreVal){
         this.$Toast("请选择城市书院");
        return;
      }

      if(this.type==4&&this.currentData.activityType == 1){
          this.showDialog = true;
          this.showForm = false;
          this.showPrice = true;
          this.showCusmtorPay = true;
      }else{
        this.getPriceData();
      }
    },

  // 自定义价格支付
   //  自定义价格支付
  useCustomPay(){
    let that = this;
    let price = that.payMoney;
    let reg = /^[0-9\.]+$/;
    if(!reg.test(price)){   //  只能是数字
      this.$Toast("请输入正确价格");
        return;
    }else{
      console.log('继续支付')
      that.submitOrder();
    }

  },
  
    // 获取报名价格明细
    async getPriceData() {
      let that = this;
      let res = await this.$api.getPriceData({
        phone: this.phone,
        name: this.name,
        agentPhone: this.invitePhone,
        classId: this.currentId,
        type: this.type,
      });
      if (res.data.code == "0000") {
        this.priceData = res.data.data.priceRsp;
        this.userData = res.data.data.user;
        let pricedata = res.data.data.priceRsp;
        if(that.currentData.source==1){
          if(
            res.data.data.priceRsp.payAmount != 0 ||
            res.data.data.priceRsp.payAmount != "0.00"
          ){
            that.goPay();
          }else {
            that.submitOrder();
          }
        }else{   // 小程序创建的活动免费报名
           that.submitOrder();
        }
       
      } else {
       let msg = res.data.msg;
        if(msg.indexOf('账号异常')>-1){
          this.showDialog = true
          this.abnormalView = true
          this.showForm = false;
          this.showPrice = false;
        }else{
          this.$Toast({
            message:res.data.msg,
            duration: 2000
          });
        }
        return;
      }
    },

    // 提交订单
    async submitOrder() {
      var that = this;
      let datas = that.currentData;
      // that.showPrice = false;
      // that.showForm = false;
      // that.showSummerForm = true;
      // return
      let res = await this.$api.createdOrder({
        phone: this.phone,
        name: this.name,
        agentPhone: this.invitePhone,
        classId: this.currentId,
        type: this.type,
        userId:this.childData.userId||'',
        childId:this.childData.childId||'',
        code: this.code,
        userPrice:this.currentData.activityType==1?this.payMoney:'',
        payType:this.clientType=='wecht'?1:2,
        cityStoreId:datas.isCityStore == 1?that.bookStoreVal:'',
      });
      if (res.data.code == "0000") {
        let data = res.data.data;
        that.currentOrderData = data;
        if(this.clientType=='wecht'){
        if(this.currentData.activityType==1){
          if(data.orderPayAmount != 0 || data.orderPayAmount != '0.00'){
            if(this.type == 2){
              let payData = JSON.parse(data.expend.pay_info);
              console.log(payData,'payData===============')
              this.StartWeiXinPay(payData);
            }else{
               this.StartWeiXinPay(data);
            }
            
          }else{
              this.$Toast("报名成功");
              that.showPrice = false;
              that.showForm = false;
              that.showDialog = false;
          }
        }else{
          if(this.currentData.source==2){
              this.$Toast("报名成功");
              that.showPrice = false;
              that.showForm = false;
              that.showDialog = false;

          }else{
            if (
              this.priceData.payAmount != 0 ||
              this.priceData.payAmount != "0.00"
            ) {
              if(this.type == 2){
              let payData = JSON.parse(data.expend.pay_info);
              console.log(payData,'payData===============')
              this.StartWeiXinPay(payData);
            }else{
               this.StartWeiXinPay(data);
            }
            } else {
              this.$Toast("报名成功");
              that.showPrice = false;
              that.showForm = false;
              if(that.type==2){
                that.showDialog = true;
                that.showSummerForm = true;
              }else{
                that.showDialog = false;
                that.showSummerForm = false;
              }
            }
          }
        }
        }else{   //   支付宝支付
          if(data.orderPayAmount != 0 || data.orderPayAmount != '0.00'){
            window.location.href = data.expend.qrcode_url;
          }else{
            this.$Toast("报名成功");
            that.showPrice = false;
            that.showForm = false;
            that.showDialog = false;
          }
        }
      }else{
        this.$Toast({
            message:res.data.data,
            duration: 2000
        });
      //  let msg = res.data.data;
      //   if(msg.indexOf('账号异常')>-1){
      //     this.showDialog = true
      //     this.abnormalView = true
      //     this.showForm = false;
      //     this.showPrice = false;
      //   }else{
      //     this.$Toast({
      //       message:res.data.data,
      //       duration: 2000
      //     });
      //   }
         return
      }
    },
    StartWeiXinPay(pay_params) {
      if (typeof WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady(pay_params),
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent(
            "WeixinJSBridgeReady",
            this.onBridgeReady(pay_params)
          );
          document.attachEvent(
            "onWeixinJSBridgeReady",
            this.onBridgeReady(pay_params)
          );
        }
      } else {
        this.onBridgeReady(pay_params);
      }
    },

    handlePicSuccess(file,e){
      // console.log(file,'file----------',e,'eeeeeee==============')
      if(file&&file.code=='0000'){
        this.payPic.push(file.data.url)
      }
    },

    onBridgeReady(pay_params) {
      var that = this;
      WeixinJSBridge.invoke("getBrandWCPayRequest", pay_params, function (res) {
        // console.log("res=====", res);
        if (res.err_msg === "get_brand_wcpay_request:ok") {
          // 支付成功的处理逻辑
             alert("支付成功");
             if(that.type==2){
                that.showDialog = true;
                that.showSummer = false;
                that.showPrice = false;
                that.showSummerForm = true;
             }else{
               that.showPrice = false;
               that.showForm = false;
               that.showDialog = false;
               that.showCusmtorPay = false;
             }
        } else {
          // 支付失败或取消支付的处理逻辑
            alert("支付失败,请重新扫码进入");
            that.showPrice = false;
            that.showForm = false;
            that.showDialog = false;
            that.showCusmtorPay = false;
            // window.WeixinJSBridge.call('closeWindow')  
        }
      });
    },
    getWechatCode() {
      if (isWechat) {
        // let appid = "wx8d38eff004c250d7"; //微信APPid--测试
        let appid; //微信APPid
        // let appid = "wx2cf92359387650da"; //微信APPid
        if(this.type == 2){   // 领袖营
          appid = "wx2cf92359387650da"; //微信APPid
        }else{
          appid = "wx8d38eff004c250d7"
        }
        let code = this.getUrlCode().code; //是否存在code
        // let local = 'http://dda.guoyifang55.com/?codes=6TlbRG&currentId=1854&jump=1&type=4';
        let local = window.location.href;
        if (code == null || code === "") {
          //不存在就打开上面的地址进行授权
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            // uri +
            encodeURIComponent(local) +
            "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        } else {
          this.code = code;
          // console.log(code,'code----------------')
          // this.getOpenId()
        }
      }
    },
    async getOpenId(){    //   oD2j0wNgZMEEN-qk0yB_erSYwG5I
      if(this.code){
         let result = await this.$api.getOpenid({
          appid: 'wx2cf92359387650da',
          code:this.code,
          secret:'app_secret',
          // secret:'wx_secret',
          'grant_type': 'authorization_code',
        });
        console.log(result,'result-------------------')

      }

    },
    // 跳转支付宝链接
    getAlipayCode() {
       window.location.href ="alipays://platformapi/startapp?saId=10000007&qrcode=https://qr.alipay.com/bax045392vfgellrodm00007"
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    closeAbnormal(){
      this.abnormalView = false;
      this.showDialog = false;
    },

    //   立即报名，打开表单弹窗
    goSign() {
        // this.showDialog = true;
        // this.showSummerForm = true;
        // this.showSummer = true;
        // this.IDNumber = '';
      if(this.type == 2){
        this.showDialog = true;
        this.showSummer = true;
        // this.IDNumber = '';
      }else{
        this.showDialog = true;
          this.showForm = true;
          this.showPrice = false;
          this.phone = "";
          this.name = "";
          this.invitePhone = "";
          this.payMoney = '';
          this.bookStoreVal = '';
       
      }
    },
    // 取消报名
    cancelSign() {
      this.showDialog = false;
      this.showForm = false;
      this.showPrice = false;
      this.showSummer = false;
      this.showSummerForm = false;
      this.showCusmtorPay = false;
      this.phone = "";
      this.name = "";
      this.invitePhone = "";
      this.IDNumber = "";
      this.payMoney = '';
      this.bookStoreVal = '';

    },
    // 支付，提交订单
    goPay() {
      this.showDialog = true;
      this.showForm = false;
      this.showPrice = true;
    },
    // 手机号
    phoneFn(val) {
      this.phone = val.target.value;
    },
    // 身份证号
    idNumberFun(val){
      this.IDNumber = val.target.value;
    },
    // 姓名
    nameFn(e) {
      this.name = e.target.value;
    },
    // 邀请人手机号
    invitePhoneFn(val) {
      this.invitePhone = val.target.value;
    },
    // 自定义价格
    getPayMoney(val){
      this.payMoney = val.target.value;

    },
    clothingSizeFun(val){
      this.clothingSize = val
    },
    sexFun(val){
      this.sex = val
    },
    joinNumFun(val){
      this.joinNum = val;
    },
    summerNameFn(e){
      this.summerName = e.target.value;
    },
    ageFn(e){
        this.summerAge = e.target.value;
    },
    heightFn(e){
      this.height = e.target.value;
    },
    weightFn(e){
      this.weight =  e.target.value;
    },
    cityNameFn(e){
      this.cityName =  e.target.value;
    },
    nationFn(e){
      this.nation = e.target.value;
    },
    expectContentFn(e){
      this.expectContent =  e.target.value;
    },
    remarksFun(e){
    this.remarks =  e.target.value;
    },
    identityNumFun(e){
      this.identityNum = e.target.value;
      this.searchChildInfo(e.target.value)

    },
    dateTypeFun(val){
      this.dateType = val
    },
    idTypeFun(val){
      this.idType = val;
    },
    birthdayFn(e){
      this.birthday = e.target.value;
    },
    parentNameFn(e){
      this.parentName = e.target.value;
    },
     parentPhoneFn(e){
      this.parentPhone = e.target.value;
    },
    agentPhoneFn(e){
      this.agentPhone = e.target.value;
    },
    // 查询回显小孩信息
    async searchChildInfo(val){
      let that = this;
      let res = await this.$api.queryChildInfo({
        identityNum:val,
        idType:that.idType
      })
       if (res.data.code == "0000"&&res.data.data) {
        let data = res.data.data;
        that.oldChildData = res.data.data;
        that.summerAge = data.age;
        that.birthday = data.birthday;
        that.clothingSize = data.clothingSize.toString();
        that.height = data.height;
        that.identityNum = data.identityNum;
        that.idType = data.idType.toString();
        that.joinNum = data.joinNum.toString();
        that.sex = data.sex.toString();
        that.weight = data.weight;
        that.cityName = data.cityName;
        that.nation = data.nation;
        that.expectContent = data.expectContent;
        that.remarks = data.remarks;
       }


    },










  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  deactivated() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>

<style scoped lang="scss">
.home-wapper {
  background: #f8f8f8;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.home-top-bg {
  width: 100%;
  height: 220px;
  box-sizing: border-box;
  z-index: 10;
  img {
    width: 100%;
    height: 220px;
  }
}
.home-title {
  background-color: rgb(247, 240, 227);
  box-sizing: border-box;
  margin-bottom: 6px;
  margin-top: 18px;
  padding-top: 10px;
  border-radius: 5px;
  padding: 10px;
}
.title {
  font-weight: 900;
  color: #6f4630;
  font-size: 20px;
}
.title-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #8d806d;
  font-size: 14px;
}
.infoBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #8d806d;
  font-size: 14px;
  margin-top: 12px;
}

.classContent {
  background-color: rgb(247, 240, 227);
  padding: 16px;
  // margin-bottom: 80px;
  box-sizing: border-box;
  margin-top: 25px;
  border-radius: 5px;
  font-size: 14px;
}
.topView{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-weight: 900;
    color: #6F4630;
    font-size: 18px;
    padding: 12px;
    box-sizing: border-box;
    // margin-bottom: 25px;
}
.abnormalBox{
    padding: 12px;
    box-sizing: border-box;
  }
 .abnormalText{
    color: #f00;
    font-size: 17px;
    font-weight: 700;
  }
  .gyfImg{
    width: 70%;
    // margin-left: 5%;
  }

.classDes {
  color: #000001;
  font-size: 14px;
  line-height: 26px;
  margin-top: 15px;
  box-sizing: border-box;
  padding-bottom: 15px;
  width: 100%;
  overflow: hidden;
  ::v-deep .image-wrap {
    width: calc(100%) !important;
    height: 100%;
    img {
      width: 100% !important;
      height: 100%;
    }
  }
}

// ::v-deep .big_text img {
//   max-width: 100%;
// }

.btnView {
  width: 100%;
  position: fixed;
  padding: 0 16px;
  bottom: 10px;
  box-sizing: border-box;
  z-index: 90;
  // height: 50px;
}
.btnBox {
  background: #6f4630;
  box-shadow: 0px 2px 10px 0px rgba(111, 70, 48, 0.3);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 18px;
  font-weight: 900;
  color: #fff;
  text-shadow: 0px 2px 10px rgba(111, 70, 48, 0.3);
  padding: 16px;
  box-sizing: border-box;
  z-index: 90;
}

// 报名弹窗
.dialog {
  position: fixed;
  width: 100vw;
  height: 120vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  padding: 100px 28px 130px;
  box-sizing: border-box;
  z-index: 99;
}
.maskBox {
  position: fixed;
  top: 10%;
  left: 10%;
  width: 80%;
  background: #fff;
  border-radius: 9px;
  padding-bottom: 15px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.maskTitle {
  width: 100%;
  height: 40px;
  font-weight: 900;
  text-align: center;
  color: #fff;
  font-size: 18px;
  line-height: 40px;
  margin-bottom: 10px;
  background-color: #6f4630;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.mask-box {
  box-sizing: border-box;
  text-align: left;
  font-weight: bold;
  color: #8d806d;
  font-size: 14px;
  margin-top: 10px;
  padding: 0px 16px;
  min-height: 200px;
  max-height: 400px;
  background: #fff;
  overflow-y: auto;
}
.mask-Pricebox {
  box-sizing: border-box;
  text-align: left;
  font-weight: bold;
  color: #8d806d;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 0px 16px;
  min-height: 100px;
  background: #fff;
}
.payMask-box{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  box-sizing: border-box;
  color: #634334;
}
.shop-info-input{
  border: 1px solid #634334;
  height: 40px;
  border-radius: 5px;
  text-align: left;
  padding-left: 5px;
  margin-left: 10px;
}
.formItem1{
   margin-bottom: 10px;
   .home-label{
    font-size: 12px;
    font-weight: normal;
   }
  .dressBox{
    padding: 8px 10px;
    padding-bottom: 0px;
    box-sizing: border-box;
    border: 1px #999 solid;
    width: 100%;
    border-radius: 5px;
    .el-radio{
      width: 40px;
      margin-bottom: 5px;
      color: #8d806d;
      font-size: 12px;
    }
  }
  .numberBox{
    padding: 8px 10px;
    padding-bottom: 0px;
    box-sizing: border-box;
    border: 1px #999 solid;
    .el-radio{
      width: 80px;
      margin-bottom: 5px;
      color: #8d806d;
      font-size: 12px;
    }
  }
  .avatar-uploader{
    display: inline-block;
  }
  .uploadText{
    display: inline-block;
    width: 50px;
    height: 63px;
    border: 1px #999 solid;
    // margin-top: 10px;
    border-radius: 5px;
    text-align: center;
    line-height: 63px;
    margin-bottom: 5px;
  }
  .picBox{
    width: 50px;
    height: 63px;
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 5px;
    position: relative;
  }
  .picItem{
    width: 50px;
    height: 63px;
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 5px;
  }
  .delText{
    position: absolute;
    right: 0;
    bottom: 0;
    display: inline-block;
    padding: 3px;
    box-sizing: border-box;
    background: #ccc;
    font-size: 12px;
    color: red;
  }
  .uploadBox{
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 10px;
    box-sizing: border-box;
  }
  input{
    padding: 8px 10px;
    box-sizing: border-box;
    border: 1px #999 solid;
    outline: none;
    height: 50px;
    width: 100%;
    font-size: 14px;
    border-radius: 5px;
    font-weight: 400;
    color: #000000;
    margin-top: 10px;
    // text-align: right;
    // box-sizing: border-box;
  }
}

.formItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 5px;
  font-weight: 400;
  color: #000000;
  font-size: 12px;
  line-height: 40px;
  margin-bottom: 10px;
  padding: 0px 10px;
  box-sizing: border-box;
  border: 1px #999 solid;
  input {
    border: none;
    outline: none;
    height: 50px;
    width: 150px;
    font-size: 14px;
    border-radius: 5px;
    font-weight: 400;
    color: #000000;
    text-align: right;
    box-sizing: border-box;
    font-size: 12px;
  }
  .el-radio{
    width:20px;
    height: 20px;
    margin-left: 10px;
    margin-right: 10px;
  }
  .el-radio__input{
    margin-left: 10px;
    // margin-top: 10px;
  }
  .el-radio__label{
      display: inline-block;
      margin-left: 10px;
      margin-top: 10px;
      margin-right: 10px;
  }
  .el-select{
    border: none;
    outline: none;
    height: 50px;
    width: 170px;
    font-size: 12px;
    border-radius: 5px;
    font-weight: 400;
    color: #000000;
    text-align: right;
  }
  .el-input{
     border: none;
    outline: none;
    height: 50px;
  }
  .el-input__inner{
    border: none !important;
    outline: none !important;
  }

  .home-label {
    display: flex;
    flex: 1;
    text-align: left;
    color: #8d806d;
    font-size: 12px;
  }
  .telBox {
    flex: 1;
    text-align: left;
  }
  .go-choose-phone {
    width: 90px;
    background: #ecce88;
    font-size: 14px;
    color: #874c2f;
    border-radius: 5px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }
}
.priceInfoBox {
  margin-bottom: 6px;
  font-weight: 500;
}

.signView {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30rpx;
  box-sizing: border-box;
  padding: 0 20px;
}
.btn0 {
  width: 110px;
  height: 35px;
  border-radius: 6px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
}
.btn1{
   width: 100%;
  height: 35px;
  border-radius: 6px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
}
</style>
<style >
.image-wrap {
  width: 100% !important;
  height: 100%;
}
.el-input{
     border: none;
    outline: none;
    height: 50px;
    width: 170px;
    text-align: right;
  }
  .el-input__inner{
    border: none !important;
    outline: none !important;
    text-align: right !important;
    width: 100% !important;
    line-height: 50px !important;
    margin-top: 8px;
    padding-right: 0 !important;
  }
  .el-input__suffix{
    display: none;
  }
</style>
